import { useFormik } from "formik";
import * as Yup from 'yup';
import contacto_formulario from '../../../assets/images/planning_info.svg';
import { Button, Box, TextField, Typography, CircularProgress } from "@mui/material";
import useStyles from "./styles";
import { ClientServices } from "../../../services/client.service";
import useAlertStore from "../../../state/alertState";
import { useState } from "react";

const ContactContent = () => {
  const classes = useStyles();
  const { showAlert } = useAlertStore();
  const [loading, setLoading] = useState<boolean>(false)

  const formik = useFormik({
    initialValues: {
      name: '',
      email: '',
      companyName: '',
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Campo obligatorio'),
      email: Yup.string().email('Email no válido').required('Campo obligatorio'),
      companyName: Yup.string().required('Campo obligatorio'),
    }),
    onSubmit: async (values: any) => {
      setLoading(true)
      const bodyAxios = {
        ...values,
        emailAx: `info@axeleratum.com`,
      };
      await ClientServices.getInstance().postConsultaEmail(bodyAxios).then(async (e) => {
        console.log(e)
        if (e.codigo !== 0) {
          showAlert(
            'failed',
            'Deberá esperar al menos 30 minutos antes de volver a solicitar información.',
            true
          );
        } else {
          console.log(e)
          showAlert(
            'success',
            'Información enviada correctamente, en breve nos pondremos en contacto',
            true
          );
          formik.resetForm()
        }
      }).catch(() => {
        showAlert(
          'failed',
          'Deberá esperar al menos 30 minutos antes de volver a solicitar información.',
          true
        );
      })
      setLoading(false)
    },
  });

  return (
    <div>
      <section id="contacto" className={classes.section}>
        <Box className={classes.container}>
          <Box className={classes.itemContainer}>
            <div className={classes.leftContainer}>
              <h2 className={classes.heading}>¿Listo para orquestar tu estrategia?</h2>
              <div className={classes.imageContainer}>
                <img className={classes.image} src={contacto_formulario} width={'100%'} alt="¿Listo para orquestar tu estrategia?" />
              </div>
            </div>
          </Box>
          <Box className={classes.rightContainer}>
            <form onSubmit={formik.handleSubmit} className={classes.formContainer}>
              <Typography>Nombre completo</Typography>
              <TextField
                fullWidth
                /* label="Nombre completo" */
                name="name"
                placeholder="Nombre completo"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name ? String(formik.errors.name) : ''}
                margin="none"
                className={classes.customTextField}
              />
              <Typography>Correo electrónico</Typography>
              <TextField
                fullWidth
                placeholder="Correo electrónico"
                name="email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email ? String(formik.errors.email) : ''}
                margin="none"
                className={classes.customTextField}
              />
              <Typography>Nombre de la empresa</Typography>
              <TextField
                fullWidth
                placeholder="Nombre de la empresa"
                name="companyName"
                value={formik.values.companyName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.companyName && Boolean(formik.errors.companyName)}
                helperText={formik.touched.companyName && formik.errors.companyName ? String(formik.errors.companyName) : ''}
                margin="none"
                className={classes.customTextField}
              />
              <Button
                color="primary"
                variant="contained"
                type="submit"
                className={classes.button}
                disabled={loading}
                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {loading ? 'Enviando...' : 'Enviar'}
              </Button>
            </form>
          </Box>
        </Box>
      </section>
    </div>
  );
};

export default ContactContent;